module.exports = __webpack_public_path__ + "static/media/app-store-en.dc661524.svg";